import { render } from "./Categories.vue?vue&type=template&id=b7b1f99c&scoped=true"
import script from "./Categories.vue?vue&type=script&lang=js"
export * from "./Categories.vue?vue&type=script&lang=js"

import "./Categories.vue?vue&type=style&index=0&id=b7b1f99c&scoped=true&lang=css"

import exportComponent from "D:\\CTS_SURAJ\\City Hoardings\\City_Hoardings_Eticket\\ui-code\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7b1f99c"]])

export default __exports__